import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { NamirasoftAPIProductServer, ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftWorkspaceServer } from "namirasoft-workspace";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import WorkspaceEditPage from "./pages/WorkspaceEditPage";
import WorkspaceListPage from "./pages/WorkspaceListPage";
import WorkspaceViewPage from "./pages/WorkspaceViewPage";
import { WorkspaceLayout } from "./WorkspaceLayout";
import { WorkspaceRoutes } from "./WorkspaceRoutes";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_WORKSPACE}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_WORKSPACE = new EnvService("REACT_APP_BASE_URL_WORKSPACE", true).getString();
            let REACT_APP_BASE_URL_API_PRODUCT = new EnvService("REACT_APP_BASE_URL_API_PRODUCT", true).getString();

            let workspace = new NamirasoftWorkspaceServer(REACT_APP_BASE_URL_WORKSPACE, result.account.token_manager, result.notifier.onError);
            let product = new NamirasoftAPIProductServer(REACT_APP_BASE_URL_API_PRODUCT, result.notifier.onError);

            let servers = { workspace, product };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (<Routes>
                        <Route path={WorkspaceRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                        <Route path={WorkspaceRoutes.WorkspaceList} element={<WorkspaceListPage {...result} servers={servers} />} />
                        <Route path={WorkspaceRoutes.WorkspaceNew} element={<WorkspaceEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={WorkspaceRoutes.WorkspaceView(":id")} element={<WorkspaceViewPage {...result} servers={servers} />} />
                        <Route path={WorkspaceRoutes.WorkspaceEdit(":id")} element={<WorkspaceEditPage {...result} servers={servers} isEdit={true} />} />
                        <Route path={WorkspaceRoutes.WorkspaceCopy(":id")} element={<WorkspaceEditPage {...result} servers={servers} isEdit={false} />} />

                        {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes >))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={WorkspaceRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <WorkspaceLayout {...props}>
                {props.children}
            </WorkspaceLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;